module.exports = __webpack_public_path__ + "static/media/share.cfecf3d6.svg";